import React from "react";
import { AiFillPicture } from "react-icons/ai";
import { BsCreditCard2Front } from "react-icons/bs";
import { GrTag } from "react-icons/gr";
import { MdPercent } from "react-icons/md";
import { SlNotebook } from "react-icons/sl";
import { TbCurrencyDollar } from "react-icons/tb";

export const BILLING_CARDS: {
  label: string;
  description: string;
  icon: React.ReactNode;
  path: string;
}[] = [
  {
    label: "Services",
    description: "Manage billable services",
    icon: <TbCurrencyDollar />,
    path: "services",
  },
  {
    label: "Payments",
    description: "Manage accepted payment methods",
    icon: <BsCreditCard2Front />,
    path: "payment-methods",
  },
  {
    label: "Tax Rate",
    description: "Manage tax rates",
    icon: <MdPercent />,
    path: "tax-rate",
  },
  {
    label: "Billing Labels",
    description: "Customize invoice and payment labels",
    icon: <GrTag size={"16px"} />,
    path: "billing-labels",
  },
  {
    label: "Notes & Footer",
    description: "Add notes and a footer to invoice",
    icon: <SlNotebook />,
    path: "billing-content",
  },
  {
    label: "Logo",
    description: "Upload your company logo",
    icon: <AiFillPicture />,
    path: "billing-logo",
  },
];
